import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { USAEPayMethodPage } from './usaepay-method.page';

const routes: Routes = [
  {
    path: '',
    component: USAEPayMethodPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), TranslateModule],
  exports: [RouterModule],
})
export class USAEPayMethodPageRoutingModule {}
